const getDecimalCount = (value: string) => {
    return value.replace(',', '.').split('.')?.[1]?.length || 0;
}

export default getDecimalCount;